import {combineReducers} from '@reduxjs/toolkit'

import {generalSlice} from '../features/general/generalSlice'
import {teaserSlice} from '../features/teasers/teaserSlice'
import {stageSlice} from '../features/stages/stageSlice'
import {dealerDataSlice} from '../features/dealerData/dealerDataSlice'
import {userDataSlice} from '../features/userData/userDataSlice'
import {provinceSlice} from '../features/provinces/provinceSlice'

// tslint:disable-next-line:no-any
const rootReducer: any = combineReducers({
    dealerData: dealerDataSlice.reducer,
    general: generalSlice.reducer,
    teasers: teaserSlice.reducer,
    stages: stageSlice.reducer,
    userData: userDataSlice.reducer,
    provinces: provinceSlice.reducer,
})

export default rootReducer
export type RootState = ReturnType<typeof rootReducer>
